import LoginImage from "../../assets/Login/img-1.svg";
import LoginImage2 from "../../assets/Login/img-2 1.svg";
 
import theme from "../../theme/theme";
import color from "../../constants/color";
 
 
 
 
const styles = {
 
  gridContainer: {
    alignItems: "center",
  },
  main: {
    backgroundColor: "#F1F1F1",
    py: { xs: 4, sm: 4, md: 6, lg: 0},
    height: {xs: "auto", sm: "auto", md: "100vh"},
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
  },
  // root: {
  //   height: "100vh"
  // },
  paper: {
    borderRadius: 10,
    overflow: "hidden",
    boxShadow: "none",
    border: "1px solid #DEDEDE",
  },
  formContain: {
    backgroundColor: "#fff",
  },
  headingborder: {
    width: "20%",
    borderBottom: "3px solid #000",
    mb: 4,
  },
  passwordsection: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: 2,
  },
  mainheading: {
    mb: 1,
    fontWeight: 600,
    fontSize: "26px",
  },
  forgotpassword: {
    textAlign: "right"
  },
  forgotlink: {
    color: color.text,
    fontWeight: "500",
  },
  forgotlinks: {
    // borderBottom: "3px solid #F1F1F1",
    // textDecoration: "none",
    fontSize: "12px",
    fontWeight: "500",
    color: color.text,
  },
  inputText: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#202020",
  },
 
  
  submit: {
    color: "white !important",
    borderRadius: 20,
    fontSize: "14px",
    fontWeight: "500",
    textTransform: "none",
    mt: 3,
    mb: 2,
    py: 1.5,
    backgroundColor: "#000",
    " & .css-1yt7yx7-MuiLoadingButton-loadingIndicator" :{
      position: "unset", 
    },
    "& .MuiButton-startIcon": {
      marginRight: "8px", 
      marginLeft: "-8px", 
    },
  },
  image: {
    // backgroundImage: `url("${LoginImage}")`,
    // backgroundSize: "cover",
    // backgroundRepeat: "no-repeat",
    // backgroundPosition: "center",
    // backgroundColor: "rgba(40, 170, 74, 0.2)",
    px: { xs: 3, sm: 5, lg: 8, },
    // display: { xs: "none", sm: "block" },
    // py: 4,
    justifyContent: "center",
    alignItems: "center",
    py:"6%",
    "& . css-1m9128y":{
      position:"absolute",
      bottom:4
    },
  },
  backgroundImage:{
    backgroundImage: `url("${LoginImage}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    height:"300px",
    width:"100%",
    // ml:"10% "
  },
  backgroundImage2:{
    backgroundImage: `url("${LoginImage2}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    height:"300px",
    width:"100%",
    // ml:"10% "
  },
  sliderText: {
    my: "8%",
    px: 5,
    textAlign: "center",
    // mb: "3%",
    fontWeight: "500",
    fontSize: "12px",
  },
  dots:{
    width:"100%",
    display:"flex",
    flexDirection:"row",
    alignItems:"center",
    ml:"50%",
    mb: 3,
  },
  dot1:{
    width:"3%",
    height:"5px",
    backgroundColor:color.text,
    borderRadius:"30px",
    mx:"1%"
  },
  dot2:{
    width:"5px  ",
    height:"5px",
    backgroundColor:color.text,
    borderRadius:"30px"
  },
  greyDot: {
    width: 5,
    height: 5,
    borderRadius: "50%",
    bgcolor: "grey",
    mx: 1,
  },
  socialIcons: {
    marginTop: 3,
    marginBottom: 3,
  },
  icon: {
    marginRight: "10px",
    borderRadius: "50%",
    border: "1px solid #dedede",
    padding: "8px",
    height: "20px",
    width: "20px"
 
  },
  orSection: {
    alignItems: "center",
    justifyContent: "center",
    space: { xs: 3, sm: 3, lg: 10, xl: 10 },
  },
  orText: {
    color: "#878787",
    fontSize: "12px",
    fontWeight: "400",
  },
  divider: {
    color: "#D9D9D9",
  },
  orBox: {
    justifyContent: "center",
  },
  privacyCondition: {
    mt: 3,
    color: "#878787",
    p: 0,
    // justifyContent: "center",
    display: "flex",
    // width: { sm: "90%", md: "90%", lg: "55%" },
    alignItems: "center",
  },
  termsText: {
    fontSize: "12px",
    fontWeight: "400",
    color: color.lightText,
 
  },
  imageText: {
    color: "#003400",
    fontSize: "12px",
    fontWeight: "400",
    textAlign: "center",
  },
  // slider: {
  //   height: "100%", // Set the height to fill the container
  //   width: "100%", // Set the width to fill the container
  //
 
  gridItem: {
    padding: theme.spacing(4), // Corresponds to py: 4 in MUI syntax
    backgroundColor: "#fff",
    borderRight: "1px solid #DEDEDE",
 
    [theme.breakpoints.up("sm")]: {
      paddingLeft: theme.spacing(5), // Corresponds to px: 3 in xs size
      paddingRight: theme.spacing(5), // Corresponds to px: 3 in xs size
    },
    [theme.breakpoints.up("lg")]: {
      paddingLeft: theme.spacing(9), // Corresponds to px: 5 in sm size
      paddingRight: theme.spacing(9), // Corresponds to px: 5 in sm size
    },
  },
 
 
}
 
 
 
export default styles